<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<div *ngIf="!isPageLoading && isValid" class=" {{themeService.themeCssClass}}">

    <div class=" {{themeService.themeCssClass}}">

        <div fxLayoutAlign="center" fxLayout="row wrap">
            <mat-card class="day-cards green-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Annual Work Abroad
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.totalWorkAbroadAllowance}}
                </mat-card-content>
            </mat-card>
            <mat-card class="day-cards red-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Remaining Work Abroad Days
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.remainingWorkAbroadAllowance}}
                </mat-card-content>
            </mat-card>
            <mat-card class="day-cards purple-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Work Abroad Requests
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.pendingWorkAbroadRequests}}
                </mat-card-content>
            </mat-card>
            <mat-card class="day-cards amber-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Work Abroad Days
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.pendingWorkAbroadDays}}
                </mat-card-content>
            </mat-card>
        </div>

        <div fxLayoutAlign="center" fxLayout="row wrap" class="rolling-period">
            <p>Your annual Work Abroad Days allowance <strong><u>for this period</u></strong> will reset on &nbsp;</p>
            <p class="date">{{this.displayRollingPeriod}}</p>
        </div>

        <br/>
        <div fxLayoutAlign="center" fxLayout="row wrap">
            <mat-form-field appearance="outline">
                <mat-label>Rolling Period</mat-label>
                <mat-select #selectedValue [value]="placeholderYear"
                            (selectionChange)="displayDataOnTable(selectedValue.value)">
                    <mat-option *ngFor="let year of years" [value]="year">
                        {{year}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="toggle-box">
                <mat-label ngClass="labelBeforeSlide">Current Rolling Period</mat-label>
                <mat-slide-toggle (click)="updateMatCards()" [(ngModel)]="isChecked">All Requests</mat-slide-toggle>
            </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="center" *ngIf="!isChecked">
            <div class="overlay" *ngIf="isRefresh">
                <div class="center">
                    <mat-spinner class="mat-progress-spinner" color="accent"
                                 mode="indeterminate">
                    </mat-spinner>
                </div>
            </div>
            <mat-table [dataSource]="dataSource" matSort matTableFilter #workAbroadTable>
                <ng-container *ngFor="let field of fieldNames;let i=index" matColumnDef="{{field}}">
                    <th id="header" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef class="mat-column-headers-standard">
                        {{displayNames[i]}}
                    </th>
                    <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text">
                        <div *ngIf="field!='annualLeaveTotal'&&field!='numberOfWorkAbroadDays'&&field!='dateCreated'&&field!='startDate'&&field!='endDate'&&field!='requestStatus'">
                            {{workAbroad[field] | titlecase}}
                        </div>
                        <div *ngIf="field=='annualLeaveTotal'">
                            {{workAbroad[field]}}
                        </div>
                        <div *ngIf="field=='requestStatus'">
                            {{workAbroad[field] | titlecase | removeUnderscorePipe}}
                        </div>
                        <div *ngIf="field=='dateCreated'">
                            {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf="field=='startDate' && this.isDate==true">
                            {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf="field=='startDate' && this.isDate==false">
                            {{'...'}}
                        </div>
                        <div *ngIf="field=='endDate' && this.isDate==true">
                            {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf="field=='endDate' && this.isDate==false">
                            {{'...'}}
                        </div>
                        <div *ngIf="field=='numberOfWorkAbroadDays'">
                            {{workAbroad[field]}}
                        </div>
                        <div *ngIf="field=='modify'&&workAbroad['requestStatus']=='PENDING'&&workAbroad['requestStatus']!='APPROVED'&&checkIfStartDateBeforeCurrentDate(workAbroad['startDate'], workAbroad['dateCreated'])">
                            <button id="modify" (click)="openModifyPopup(modifyEmployee, workAbroad, true)" class="close-button-right">Edit</button>
                        </div>
                        <div *ngIf="field=='cancel'&&workAbroad['requestStatus']!='CANCELLED'&&workAbroad['requestStatus']!='APPROVED'&&workAbroad['requestStatus']!='CANCEL_REQUEST'&&workAbroad['requestStatus']!='DECLINED'&&checkIfStartDateBeforeCurrentDate(workAbroad['startDate'],workAbroad['dateCreated'])">
                            <button id="cancel" (click)="openCancelPopup(workAbroad.id)" class="close-button-right">Cancel</button>
                        </div>
                        <div *ngIf="field=='cancel'&&workAbroad['requestStatus']!='CANCELLED'&&workAbroad['requestStatus']!='DELETED'&&workAbroad['requestStatus']!='CANCEL_REQUEST'&&workAbroad['requestStatus']!='DECLINED'&&workAbroad['requestStatus']!='PENDING'">
                            <button id="requestCancel" (click)="openRequestCancelPopup(this.workAbroad)" class="close-button-right">
                                Request Cancel
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNames;"
                    [ngClass]="{blueBackground : even}"></tr>
            </mat-table>
        </div>

        <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="!isChecked">
            <mat-paginator [pageSize]="5"
                           [pageSizeOptions]="[5, 10, 25, 50]"
                           showFirstLastButtons
                           class="blue">
            </mat-paginator>
        </div>

        <div fxLayout="row" fxLayoutAlign="center" *ngIf="isChecked">
            <div class="overlay" *ngIf="isRefresh">
                <div class="center">
                    <mat-spinner class="mat-progress-spinner" color="accent"
                                 mode="indeterminate">
                    </mat-spinner>
                </div>
            </div>
            <mat-table [dataSource]="dataSourceAll" matSort matTableFilter #workAbroadTableAll>
                <ng-container *ngFor="let field of fieldNames;let i=index" matColumnDef="{{field}}">
                    <th id="header1" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef class="mat-column-headers-standard">
                        {{displayNames[i]}}
                    </th>
                    <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text">
                        <div *ngIf="field!='annualLeaveTotal'&&field!='numberOfWorkAbroadDays'&&field!='dateCreated'&&field!='startDate'&&field!='endDate'&&field!='requestStatus'">
                            {{workAbroad[field] | titlecase}}
                        </div>
                        <div *ngIf="field=='annualLeaveTotal'">
                            {{workAbroad[field]}}
                        </div>
                        <div *ngIf="field=='requestStatus'">
                            {{workAbroad[field] | titlecase | removeUnderscorePipe}}
                        </div>
                        <div *ngIf="field=='dateCreated'">
                            {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                        </div>

                        <div *ngIf="field=='startDate'">
                            {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                        </div>

                        <div *ngIf="field=='endDate'">
                            {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf="field=='numberOfWorkAbroadDays'">
                            {{workAbroad[field]}}
                        </div>
                        <div *ngIf="field=='modify'&&workAbroad['requestStatus']=='PENDING'&&workAbroad['requestStatus']!='APPROVED'&&checkIfStartDateBeforeCurrentDate(workAbroad['startDate'], workAbroad['dateCreated'])">
                            <button id="modify1" (click)="openModifyPopup(modifyEmployee, workAbroad, true)" class="close-button-right">Edit</button>
                        </div>
                        <div *ngIf="field=='cancel'&&workAbroad['requestStatus']!='CANCELLED'&&workAbroad['requestStatus']!='APPROVED'&&workAbroad['requestStatus']!='CANCEL_REQUEST'&&workAbroad['requestStatus']!='DECLINED'&&checkIfStartDateBeforeCurrentDate(workAbroad['startDate'],workAbroad['dateCreated'])">
                            <button id="cancel1" (click)="openCancelPopup(workAbroad.id)" class="close-button-right">Cancel</button>
                        </div>
                        <div *ngIf="field=='cancel'&&workAbroad['requestStatus']!='CANCELLED'&&workAbroad['requestStatus']!='DELETED'&&workAbroad['requestStatus']!='CANCEL_REQUEST'&&workAbroad['requestStatus']!='DECLINED'&&workAbroad['requestStatus']!='PENDING'">
                            <button id="requestCancel1" (click)="openRequestCancelPopup(this.workAbroad)" class="close-button-right">
                                Request Cancel
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNames;"
                    [ngClass]="{blueBackground : even}"></tr>
            </mat-table>
        </div>

        <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="isChecked">
            <mat-paginator [pageSize]="5"
                           [pageSizeOptions]="[5, 10, 25, 50]"
                           showFirstLastButtons
                           class="blue">
            </mat-paginator>
        </div>

        <div fxLayoutAlign="center" fxLayout="row wrap">
            <button class="buttons" *ngIf="!isExcelExporting" mat-raised-button color="primary" type="button" (click)="exportExcel()">
                Export Excel
            </button>
            <button class="buttons" mat-raised-button color="primary" type="button" (click)="openWorkAbroadPopup(employee)">
                New Work Abroad Request
            </button>
        </div>

        <div *ngIf="employee.region=='IRL'">
            <div fxLayoutAlign="center" fxLayout="row wrap">
                <footer fxLayoutAlign="center" fxLayout="row wrap" class="footer">
                    <p>Note: Leave taken during public holidays will not be deducted from your total annual leave entitlement. Please refer to the
                        <a style="font-weight:bold" target="_blank" rel="noopener noreferrer"
                           href="https://socrates.gm.com/content/dam/socrates/documents/irl/Documents/2025-Ireland-Vacation-and-Holiday-Dates.pdf">Holiday Calendar</a>
                        for a list of upcoming holidays.</p>
                    <p><a style="font-weight:bold" target="_blank" rel="noopener noreferrer"
                          href="https://socrates.gm.com/content/dam/socrates/documents/irl/Documents/Employee-Handbook-General-Motors-IT-Services-Ireland-Limited_V19_October-2022.pdf">
                        &nbsp;Find your Employee Handbook here</a></p>
                </footer>
            </div>
        </div>

        <div *ngIf="employee.region=='GBR'">
        <div fxLayoutAlign="center" fxLayout="row wrap">
            <footer fxLayoutAlign="center" fxLayout="row wrap" class="footer">
                <p>Note: Leave taken during public holidays will not be deducted from your total annual leave entitlement. Please refer to the
                    <a style="font-weight:bold" target="_blank" rel="noopener noreferrer"
                       href="https://socrates.gm.com/content/dam/socrates/documents/gbr/documents/GM%20UK%20Employee%20Handbook_V4.pdf">Holiday Calendar</a>
                    for a list of upcoming holidays.</p>
                <p><a style="font-weight:bold" target="_blank" rel="noopener noreferrer"
                      href="https://socrates.gm.com/content/dam/socrates/documents/gbr/documents/GM%20UK%20Employee%20Handbook_V4.pdf">
                    &nbsp;Find your Employee Handbook here</a></p>
            </footer>
        </div>
            </div>

        <fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
    </div>
</div>
<div *ngIf="!isValid">
    <p class="invalid-user">As an employee you are not onboarded onto the system.</p>
    <p class="invalid-user">If you need to log your vacations via the vacation tracker,</p>
    <p class="invalid-user">Please contact HR or your manager for further assistance</p>
</div>